import Common from "js/_core/Common";
import {deepMerge} from 'js/utils/Utils'
import {clamp} from "js/utils/Maths";

const defaults = {
    instanceName: 'scrollProgressAnimation',
}

export default class ScrollProgressAnimation {
    constructor(options = {}) {
        deepMerge(this, defaults, options);
    }

    init() {
        this._addHandlers()
    }

    destroy() {
        this._removeHandlers()
    }

    _addHandlers() {
        if (Common.raf) {
            Common.raf.addHandler(() => {
                this.onRaf();
            }, this.instanceName);
        }

        if (Common.resize) {
            Common.resize.addHandler(() => {
                this.onResize();
            }, this.instanceName);
        }

    }

    _removeHandlers() {
        if (Common.raf) {
            Common.raf.removeHandler(this.onRaf, this.instanceName);
        }

        if (Common.resize) {
            Common.resize.removeHandler(this.onResize, this.instanceName);
        }
    }

    // スクロールの開始位置
    // 場合によって計算方法を書き換える
    get start() {
        return 0;
    }

    // スクロールの終了位置
    // 場合によって計算方法を書き換える
    get end() {
        return 100;
    }

    // スクロールの進捗量
    get amount() {
        return this.end - this.start;
    }

    // スクロールの進捗率
    get progress() {
        const currentScroll = Common.scroll.currentScroll - this.start;
        return clamp(currentScroll / this.amount, 0, 1); // 0 ~ 1
    }

    onResize() {
    }

    onRaf() {
    }
}